import React, {useState, useEffect} from 'react';

import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';

import * as Constant from '@app/Constant.js';
import axios from '@app/lib/axios';

import crypto from 'crypto';

import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

const BRANCH_ACCOUNT_APP_LIST_CAN_USE = ['tomonote', 'tomobooks', 'tomoenglish', 'playdd', 'jelliing'];
const getAppNameList = (params) => {
    let result = [];
    if(params.data.tas) {
        result.push('TAS');
    }
    if(params.data.tomonote) {
        result.push('토모노트');
    }
    if(params.data.playdd) {
        result.push('플레이딩동');
    }
    if(params.data.tomonote || params.data.momo) {
        result.push('모모한글수');
    }
    if(params.data.tomobooks) {
        result.push('별별책방');
    }
    if(params.data.tomoenglish) {
        result.push('플라잉 영어');
    }
    if(params.data.jelliing) {
        result.push('젤링');
    }
    return result.join('/');
};
const BranchBizAccountList = ({serviceAppList, branch, bizApp, account, type, reloadAccount}) => {
    const [tasList, setTasList] = useState(null);
	const [teacherList, setTeacherList] = useState(null);
    const [selectedData, setSelectedData] = useState(null);

	useEffect(() => {
        const _tasList = [];
        const _teacherList = [];
        if (account) {
            account.forEach((a) => {
                if(a.role =='B') _tasList.push(a)
                else _teacherList.push(a)
            });
        }
        setTasList(_tasList)
        setTeacherList(_teacherList)
        return () => {};
    }, [branch, account]);

    let gridApi = null;

    let listColumn = [
        {
            headerName: "",
            headerClass:'bg-dark text-light',
            field: "no",
            sortable: false,
            width : 50,
            resizable : true,
            cellClass: "text-center",
            filter: false
        },
        {
            headerName: "구분",
            headerClass:'bg-dark text-light',
            field: "biz_type",
            sortable: false,
            width : 100,
            resizable : true,
            filter: false,
            cellRenderer: (params) => {
                let result = '';
                switch (params.value) {
                    case 'B' : result = '지사장'
                        break;
                    case 'E' : result = '직원'
                        break;
                    case 'L' : result = '영어강사'
                        break;
                }
                return result;
            }
        },
        {
            headerName: "계정",
            headerClass:'bg-dark text-light',
            field: "user_id",
            sortable: false,
            width : 120,
            resizable : true,
            filter: false
        },
        {
            headerName: "사용자",
            headerClass:'bg-dark text-light',
            field: "name",
            sortable: false,
            width : 120,
            resizable : true,
            filter: false
        },
        {
            headerName: "접속 권한",
            headerClass:'bg-dark text-light',
            field: "id",
            sortable: false,
            resizable : true,
            filter: false,
            cellRenderer: (params) => {
                return getAppNameList(params);
            }
        },
        {
            headerName: "상태",
            headerClass:'bg-dark text-light',
            field: "status",
            sortable: false,
            width : 80,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                let result = '';
                switch (params.value) {
                    case 'terminate' : result = '<span class="text-danger">미사용</span>'
                        break;
                    case 'waiting' : result = '<span class="text-primary">사용요청</span>'
                        break;
                    case 'active' : result = '<span class="text-success">사용</span>'
                        break;
                }
                return result;
            }
        },
        {
            headerName: "상태 변경",
            headerClass:'bg-dark text-light',
            field: "status",
            sortable: false,
            width : 100,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                let result = '';
                if(params.data.role == 'B') return result;
                switch (params.value) {
                    case 'terminate' : 
                        result = '<button class="btn btn-brand btn-rounded font-12" style="padding: 1px 5px" onClick="changeStatus('+params.data.id+', \'waiting\')">사용요청</button>'
                        break;
                    case 'waiting' : 
                        result = '<button class="btn btn-default btn-rounded text-danger font-12" style="padding: 1px 5px" onClick="changeStatus('+params.data.id+', \'terminate\')">미사용처리</button>'
                        break;
                    case 'active' : 
                        result = '<button class="btn btn-default btn-rounded text-danger font-12" style="padding: 1px 5px" onClick="changeStatus('+params.data.id+', \'terminate\')">미사용처리</button>'
                        break;
                }
                return result;
            }
        },
        {
            headerName: "정보 수정",
            headerClass:'bg-dark text-light',
            field: "id",
            sortable: false,
            width : 80,
            resizable : true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (params) => {
                return '<button class="btn btn-default btn-rounded font-12" style="padding: 1px 5px" onClick="openInfoModal('+params.value+')">수정</button>';
            }
        }
    ];
        
    
    if(type ==='admin') {
        listColumn = [
            {
                headerName: "",
                headerClass:'bg-dark text-light',
                field: "no",
                sortable: false,
                width : 50,
                resizable : true,
                cellClass: "text-center",
                filter: false
            },
            {
                headerName: "구분",
                headerClass:'bg-dark text-light',
                field: "biz_type",
                sortable: false,
                width : 80,
                resizable : true,
                filter: false,
                cellRenderer: (params) => {
                    let result = '';
                    switch (params.value) {
                        case 'B' : result = '지사장'
                            break;
                        case 'E' : result = '직원'
                            break;
                        case 'L' : result = '영어강사'
                            break;
                    }
                    return result;
                }
            },
            {
                headerName: "계정",
                headerClass:'bg-dark text-light',
                field: "user_id",
                sortable: false,
                width : 110,
                resizable : true,
                filter: false
            },
            {
                headerName: "사용자",
                headerClass:'bg-dark text-light',
                field: "name",
                sortable: false,
                width : 110,
                resizable : true,
                filter: false
            },
            {
                headerName: "접속 권한",
                headerClass:'bg-dark text-light',
                field: "id",
                sortable: false,
                resizable : true,
                filter: false,
                cellRenderer: (params) => {
                    if(params.data.status != 'active') return '';
                    let result = '';
                    if(bizApp) {
                        BRANCH_ACCOUNT_APP_LIST_CAN_USE.map((a) => {
                            if(params.data.biz_type == 'B' || params.data.biz_type == 'E' || (params.data.biz_type == 'L' && (a == 'tomoenglish' || a == 'jelliing')))  {
                                const ba = bizApp.find((ba) => a == ba);
                                const sa = serviceAppList.find((sa) => a == sa.appId);
                                let appCheck = `<input id="use_app_${params.data.id}_${a}" type="checkbox" name="use_app_${params.data.id}_${a}" value="active" ${params.data[a] && params.data[a] == 'AP' ? 'checked' : ''} onChange="changeApproval(${params.data.id}, '${a}', '${params.data[a] && params.data[a] == 'AP' ? 'NA' : 'AP'}')" style="display: inline-block"/>`
                                            + `<label class="font-12 mr-2 ${ba ? 'text-danger' : ''}" for="use_app_${params.data.id}_${a}">${sa ? sa.name : ''}</label>`;
    
                                result += appCheck;
                            }
                        });
                    }
                    return result;
                }
            },
            {
                headerName: "상태",
                headerClass:'bg-dark text-light',
                field: "status",
                sortable: false,
                width : 80,
                resizable : true,
                cellClass: "text-center",
                filter: false,
                cellRenderer: (params) => {
                    let result = '';
                    switch (params.value) {
                        case 'terminate' : result = '<span class="text-danger">미사용</span>'
                            break;
                        case 'waiting' : result = '<span class="text-primary">사용요청</span>'
                            break;
                        case 'active' : result = '<span class="text-success">사용가능</span>'
                            break;
                    }
                    return result;
                }
            },
            {
                headerName: "처리",
                headerClass:'bg-dark text-light',
                field: "id",
                sortable: false,
                width : 130,
                resizable : true,
                cellClass: "text-center",
                filter: false,
                cellRenderer: (params) => {
                    if(params.data.role == 'B') return "";
                    let result = `
                        <input id="active_${params.value}" type="radio" name="status_${params.value}" value="active" ${params.data.status == 'active'? 'checked' : ''} onChange="changeStatus(${params.value}, '${params.data.biz_type}', 'active')" style="display: inline-block"/>
                        <label class="font-12 mr-2" for="active_${params.value}">사용</label>

                        <input id="terminate_${params.value}" type="radio" name="status_${params.value}" value="terminate" ${params.data.status != 'active'? 'checked' : ''} onChange="changeStatus(${params.value}, '${params.data.biz_type}', 'terminate')" style="display: inline-block"/>
                        <label class="font-12" for="terminate_${params.value}">미사용</label>
                    `;

                    return result;
                }
            },
            {
                headerName: "비밀번호",
                headerClass:'bg-dark text-light',
                field: "id",
                sortable: false,
                width : 80,
                resizable : true,
                cellClass: "text-center",
                filter: false,
                cellRenderer: (params) => {
                    return '<button class="btn btn-primary btn-sm font-12" onClick="initPass('+ params.value +', \'' + (params.data.biz_type == 'B' ? `2${params.data.user_id}` : `1234`) + '\')" style="padding : 1px 3px">초기화</button>';
                }
            }
        ];
    }

    const onGridReady = (params) => {
        gridApi = params.api;
        params.api.sizeColumnsToFit();
    }

    window.changeApproval = (id, appId, approval) => {
        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/branch/account/app/approval`,
            data: {sid: id, appId, approval}
        })
        .then(res => {
            if (res.data.code == 200) {
                alert('저장 되었습니다');
                reloadAccount();
            } else {
                console.log(res.data);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            }
        })
        .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
    }

    window.changeStatus = (id, biz_type, status) => {
        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/branch/account/status/${status}/${id}`,
            data: {biz_type}
        })
        .then(res => {
            if (res.data.code == 200) {
                alert('저장 되었습니다');
                reloadAccount();
            } else {
                console.log(res.data);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            }
        })
        .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
    }

    window.initPass = (id, passStr) => {
    	if(window.confirm("비밀번호를 초기화하시겠습니까?")) {
            const pass = crypto.createHash('md5').update(passStr).digest('hex');
            axios({
                method: "patch",
                url: `${Constant.API_DOMAIN}/api/branch/account/initPass/${id}`,
                data: {pass}
            })
            .then(res => {
                alert('비밀번호를 초기화하였습니다.');
            })
            .catch(error => {
                console.log(error);
                setData(null);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
        }
    }

    window.openInfoModal = (id) => {
        const data = account.find((a) => a.id === id);
        if(data) {
            data.pass = "";
            data.pass_confirm = "";
        }
        setSelectedData(data);
    }

	return (
        <div className="row mt-4 mb-4">
            <div className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-12">
                <div className="page-header mb-2">
                    <h5 className="pageheader-title text-muted">
                        지사 계정 정보
                    </h5>
                </div>
            </div>
            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 text-right">
                <AddAccount branch={branch} type={type} reloadAccount={reloadAccount}/>
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-balham" style={{height: `110px`}}>
                <AgGridReact
                    onGridReady={onGridReady}
                    columnDefs={[
                        {
                            headerName: "TAS 접속 계정",
                            headerClass:'bg-dark text-light',
                            children : listColumn
                        }
                    ]}
                    rowHeight={40}
                    rowData={tasList}
                    suppressDragLeaveHidesColumns={true}
                    defaultColDef={{suppressMovable: true}}
                />
            </div>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-balham" style={{height: `500px`}}>
                <AgGridReact
                    onGridReady={onGridReady}
                    suppressDragLeaveHidesColumns={true}
                    defaultColDef={{suppressMovable: true}}
                    enableCellTextSelection={true}
                    columnDefs={[
                        {
                            headerName: "서비스 접속 계정",
                            headerClass:'bg-dark text-light',
                            children : listColumn
                        }
                    ]}
                    rowHeight={40}
                    rowData={teacherList}
                />
            </div>
            <ModifyAccountModal
                branch={branch}
                user={selectedData}
                hideModal={(reloadData) => {
                    setSelectedData(null);
                    if(reloadData) reloadAccount();
                }}
            />
        </div>
    );
}

const AddAccount = ({branch, reloadAccount}) => {
    const defaultValue = {
        biz_type: 'E',
        user_id: '',
        name: '',
        pass: '',
        pass_confirm: '',
        multi_use_yn: 'N',
        multi_use_count: 1
    };
    const [data, setData] = useState({...defaultValue});
    const [show, setShow] = useState(false);

    useEffect(() => {
        if(branch && show) getUserId(data.biz_type);
        return () => {};
    }, [branch, show]);

    const getUserId = (biz_type) => {
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/branch/account/userId/${biz_type}/${branch.id}`
        })
        .then(res => {
            if(res.data.code == 200) {
                const _data = {...data}
                _data.user_id = res.data.id;
                _data.biz_type = biz_type;
                setData(_data)
            } else {
                alert("생성되지 않은 ID를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                setShow(false);
            }
        })
        .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
    }

	const submitAccount = () => {
        const _data = {...data}

        if(!_data.user_id) {
            alert('발급 가능한 사용자 아이디가 조회되지 않았습니다.\n팝업창을 닫았다 다시 열어주세요.');
        }

        if(_data.pass.length < 4) {
            alert('비밀번호는 4자 이상 입력해야 합니다.');
            return;
        }
        
        if(_data.pass != _data.pass_confirm) {
            alert('비밀번호는 4자 이상 입력해야 합니다.');
            return;
        }
        
        _data.pass = crypto.createHash('md5').update(data.pass).digest('hex');
		axios({
          method: "post",
          url: `${Constant.API_DOMAIN}/api/branch/account/${branch ? branch.id : 0}`,
          data: {..._data}
        })
        .then(res => {
        	if(res.data.code == 200){
                if(reloadAccount) reloadAccount()
                setShow(false)
            } else {
                console.log(res.data);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");    
            }
        })
        .catch(error => {
            console.log(error);
            setData(null);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
	} 

    const changeHandler = (e) => {
        const {name, value} = e.target;
        const _data = {...data};
        _data[name] = value;
        
        if(name === 'biz_type') getUserId(value);
        else setData(_data);
    }

    return (
        <>
            <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                    setShow(true)
                    setData({...defaultValue})
                }}
            >
                <span className="fas fa-plus-circle mr-2"></span>
                지사 계정 추가
            </button>
            <Modal
	            show={show}
	            onHide={() => {
                    setShow(false)
                    setData({...defaultValue})
                }}
	            aria-labelledby="example-custom-modal-styling-title"
	        >
	            <Modal.Header closeButton>
	                <Modal.Title id="example-custom-modal-styling-title">
	                    직원 계정 추가
	                </Modal.Title>
	            </Modal.Header>
	            <Modal.Body>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="page-header mb-2">
                                <h5 className="pageheader-title text-muted font-18">
                                    {branch ? branch.name : '-'}
                                </h5>
                            </div>
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <table className="table table-bordered">
                                <colgroup>
                                    <col style={{minWidth: '100px'}}/>
                                    <col />
                                </colgroup>
                                <tr>
                                    <th className="bg-dark text-light">구분</th>
                                    <td>
                                        <label className="custom-control custom-radio custom-control-inline ">
                                            <input
                                                type="radio"
                                                name="biz_type"
                                                value="E"
                                                checked={data.biz_type == 'E'}
                                                className="custom-control-input"
                                                onChange={changeHandler} 
                                            />
                                            <span className="custom-control-label">직원</span>
                                        </label>

                                        <label className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                name="biz_type"
                                                value="L"
                                                checked={data.biz_type == 'L'}
                                                className="custom-control-input"
                                                onChange={changeHandler}
                                            />
                                            <span className="custom-control-label">영어강사</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">ID</th>
                                    <td className="text-danger" style={{backgroundColor : '#eeeeee'}}>
                                        {data.user_id && (
                                            data.user_id
                                        )}
                                        {!data.user_id && (
                                            <i className="fas fa-spinner" />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">사용자 이름</th>
                                    <td className="p-0">
                                        <input name="name" type="text" className="form-control" placeholder="반드시 입력하세요." value={data.name} onChange={changeHandler} autoComplete={false}/>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">비밀번호 입력</th>
                                    <td className="p-0">
                                        <input name="pass" type="password" className="form-control" placeholder="4자리 이상 입력하세요." value={data.pass} onChange={changeHandler} autoComplete={false} />
                                    </td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">비밀번호 확인</th>
                                    <td className="p-0">
                                        <input name="pass_confirm" type="password" className="form-control" placeholder="한번 더 입력해 주세요." value={data.pass_confirm} onChange={changeHandler} autoComplete={false} />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-danger ml-2">
                            {data.pass != data.pass_confirm && (
                                <p>* 비밀번호가 일치하지 않습니다.</p>
                            )}
                            {data.pass.length < 4&& (
                                <p>* 비밀번호는 4자 이상이어야 합니다.</p>
                            )}
                        </div>
                    </div>
	            </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-default btn-sm"
                        onClick={() => {
                            setShow(false)
                            setData({...defaultValue})
                        }}
                    >
                        취소
                    </button>
                    <button
                        className="btn btn-brand btn-sm"
                        disabled={
                            data.pass && data.pass != data.pass_confirm
                        }
                        onClick={submitAccount}
                    >
                        저장
                    </button>
                </Modal.Footer>
	        </Modal>
        </>
    )
}

const ModifyAccountModal = ({branch, user, hideModal}) => {
    const [data, setData] = useState(user);
    
    useEffect(() => {
        setData(user);
        return () => {};
    }, [branch, user]);

    if(!data) return null;

    const changeHandler = (e) => {
        const {name, value} = e.target;
        const _data = {...data};
        _data[name] = value;
        setData(_data);
    }

    const submitModifyAccount = () => {
        const _data = {...data};
        if(_data.pass) {
            if(_data.pass.length < 4) {
                alert('비밀번호는 4자 이상 입력해야 합니다.');
                return;
            }

            if(_data.pass != _data.pass_confirm) {
                alert('비밀번호는 4자 이상 입력해야 합니다.');
                return;
            }
            _data.pass = crypto.createHash('md5').update(data.pass).digest('hex')
        }

        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/branch/account/${data.id}`,
            data: {..._data}
        })
        .then(res => {
            if (res.data.code == 200) {
                alert('저장 되었습니다');
                hideModal(true);
            } else {
                console.log(res.data);
                hideModal();
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            }
        })
        .catch(error => {
            console.log(error);
            hideModal();
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
    }

    return (
        <Modal
            show={data != null}
            onHide={hideModal}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                    직원 계정 수정
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="page-header mb-2">
                            <h5 className="pageheader-title text-muted font-18">
                                {branch ? branch.name : '-'}
                            </h5>
                        </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <table className="table table-bordered">
                            <colgroup>
                                <col style={{minWidth: '100px'}}/>
                                <col />
                            </colgroup>
                            {(data.biz_type == 'E' || data.biz_type == 'L')  && (
                                <tr>
                                    <th className="bg-dark text-light">구분</th>
                                    <td>
                                        <label className="custom-control custom-radio custom-control-inline ">
                                            <input
                                                type="radio" name="biz_type" value="E" checked={data.biz_type == 'E'} className="custom-control-input"
                                                onChange={changeHandler}
                                            />
                                            <span className="custom-control-label">직원</span>
                                        </label>

                                        <label className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio" name="biz_type" value="L" checked={data.biz_type == 'L'} className="custom-control-input"
                                                onChange={changeHandler}
                                            />
                                            <span className="custom-control-label">영어강사</span>
                                        </label>
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <th className="bg-dark text-light">ID</th>
                                <td className="text-danger" style={{backgroundColor : '#eeeeee'}}>
                                    {data.user_id && (
                                        data.user_id
                                    )}
                                    {!data.user_id && (
                                        <i className="fas fa-spinner" />
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <th className="bg-dark text-light">사용자 이름</th>
                                <td className="p-0">
                                    <input id="name" name="name" type="text" autocomplete="off" className="form-control" placeholder="반드시 입력하세요." value={data.name} onChange={changeHandler}/>
                                </td>
                            </tr>
                            <tr>
                                <th className="bg-dark text-light">비밀번호 입력</th>
                                <td className="p-0">
                                    <input id="pass" name="pass" type="password" autoComplete="off" className="form-control" placeholder="4자리 이상 입력하세요." value={data.pass} onChange={changeHandler}/>
                                </td>
                            </tr>
                            <tr>
                                <th className="bg-dark text-light">비밀번호 확인</th>
                                <td className="p-0">
                                    <input id="pass_confirm" name="pass_confirm" type="password" autoComplete="off" className="form-control" placeholder="한번 더 입력해 주세요."  value={data.pass_confirm} onChange={changeHandler}/>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-danger ml-2">
                        {data.pass != data.pass_confirm && (
                            <p>* 비밀번호가 일치하지 않습니다.</p>
                        )}
                        {data.pass && data.pass.length < 4 && (
                            <p>* 비밀번호는 4자 이상이어야 합니다.</p>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    className="btn btn-default btn-sm"
                    onClick={hideModal}
                >
                    취소
                </button>
                <button
                    className="btn btn-brand btn-sm"
                    disabled={
                        data.pass ? data.pass != data.pass_confirm : false
                    }
                    onClick={submitModifyAccount}
                >
                    저장
                </button>
            </Modal.Footer>
        </Modal>
    )

}

export default BranchBizAccountList;